import React from "react"
import {connect} from "react-redux"

// Models
import {RootState} from "../../../models"

// Selectors
import {selectAuthorizing} from "../store/selectors"

/**
 * @param state
 */
const mapStateToProps = (state: RootState) => ({
    authorizing: selectAuthorizing(state),
});

/**
 * @param BaseComponent
 */
export default (BaseComponent: React.ComponentType<any>) =>
    connect(mapStateToProps, null)(BaseComponent)

export type WithAuthorizationProps = {
    authorizing: boolean
}
